import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Select from 'react-select';
import debounce from 'lodash/debounce';
import Form from "react-bootstrap/Form";
import CloseButton from 'react-bootstrap/CloseButton';
import Loader from "../Loader/index";



const CitySelectors = ({ location, setDepartureCity, setcityName, setStateName, setcountryName }) => {
  const [cityListData, setCityListData] = useState([]);
  const [cityCurrentData, setCurrentData] = useState([]);
  const [query, setQuery] = useState('');
  const [isLoading, setIsLoadinig] = useState(false);

 

  const handleChange = async (selectedOption) => {
    if (selectedOption) {
      const matchingCity = cityListData.find(item => item.address === selectedOption.address);

      if (matchingCity) {
        try {
          const finalData = await fetchLocationData(matchingCity);
          if (finalData?.city?.name && finalData?.state?.name && finalData?.country?.name) {
            setcityName(finalData.city.name);
            setStateName(finalData.state.name);
            setcountryName(finalData.country.name);
          }
          setQuery(selectedOption.address);
          setDepartureCity(selectedOption.address);
        } catch (error) {
          console.error('Error fetching location data:', error);
        }
      } else {
        console.error('No matching city found for the selected option:', selectedOption);
      }
    } else {
      clearSelection();
      console.error('Selected option is undefined or null');
    }
    setCityListData([]);
  };
  const handleInputChange = useCallback(
    debounce(async (event) => {
      const value = event.target.value;
      console.log(value)
      setQuery(value);
      if (value.trim()) {
        const final_data = await fetchData(value);
        setCityListData(final_data);
      } else {
        setCityListData([]);
      }
    }, 300),
    []
  );

  const fetchLocationData = async ({ latitude, longitude }) => {
    try {
      const response = await fetch(`https://api.jetcamer.com/geo-data/${latitude}/${longitude}`);
      if (!response.ok) throw new Error('Network response was not ok');

      return await response.json();
    } catch (error) {
      console.error('Error fetching data: ', error);
      return null;
    }
  };

  const fetchData = async (value) => {
    try {
      const response = await fetch(`https://api.jetcamer.com/location/${value}`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching data: ', error);
      setCityListData([]);
    }
  };

  const clearSelection = () => {
    setQuery('');
    setDepartureCity('');
    setcityName('');
    setStateName('');
    setcountryName('');
    setCityListData([]);
  };


  const checkData = () => {
    // console.log(query.length);
    setIsLoadinig(true);
    if (location.latitude !== undefined && location.latitude !== null && query.length === 0) {
      console.log(location);
      const getLocationAndFetchData = async () => {
        try {
          const data = await fetchLocationData(location);
          const finalData = await fetchData(data.city.name);
          setCityListData(finalData);
          setIsLoadinig(false);
        } catch (fetchError) {
          console.error("Error fetching location data:", fetchError);
        } finally {
          setIsLoadinig(false);
        }
      };
      getLocationAndFetchData();
    } else {
      setIsLoadinig(false);
    }
  };

  return (
    <>
      <div className="location_list">
        <div className="location_div">
          <Form.Control
            type="text"
            autoComplete='off'
            placeholder="Select Address*"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              handleInputChange(e);
            }}
            onClick={checkData}
          />
          <CloseButton onClick={clearSelection} />
        </div>
        {isLoading ? (
          <Loader spinner={true} visible={isLoading} className="LoaderForm" />
        ) : (
          cityListData.length > 0 && (
            <ul className="search-dropdown" id="custom_scroll">
              {cityListData.map((item, index) => (
                <li key={index} onClick={() => handleChange(item)}>
                  {item.address}
                </li>
              ))}
            </ul>
          )
        )}
      </div>
    </>
  );
};

export default CitySelectors;
